import Phaser from 'phaser';
import { WORLD_CONFIG } from '../world.config.js';

const SQRT_HALF = Math.SQRT1_2;

export class DroneController {
  constructor(scene, sprite) {
    this.scene = scene;
    this.sprite = sprite;
    this.speed = WORLD_CONFIG.droneSpeed;

    this.cursors = scene.input.keyboard.createCursorKeys();
    this.wasd = scene.input.keyboard.addKeys({
      W: Phaser.Input.Keyboard.KeyCodes.W,
      A: Phaser.Input.Keyboard.KeyCodes.A,
      S: Phaser.Input.Keyboard.KeyCodes.S,
      D: Phaser.Input.Keyboard.KeyCodes.D,
    });

    this.facing = 'down';
    this.lastMoveTime = scene.time.now;
    this.enabled = true;
  }

  setEnabled(value) {
    this.enabled = value;
  }

  update(_time, delta) {
    if (!this.enabled) return;
    const dt = delta / 1000;
    const left = this.cursors.left.isDown || this.wasd.A.isDown;
    const right = this.cursors.right.isDown || this.wasd.D.isDown;
    const up = this.cursors.up.isDown || this.wasd.W.isDown;
    const down = this.cursors.down.isDown || this.wasd.S.isDown;

    let dx = (right ? 1 : 0) - (left ? 1 : 0);
    let dy = (down ? 1 : 0) - (up ? 1 : 0);

    if (dx !== 0 && dy !== 0) {
      dx *= SQRT_HALF;
      dy *= SQRT_HALF;
    }

    if (dx !== 0 || dy !== 0) {
      this.sprite.x += dx * this.speed * dt;
      this.sprite.y += dy * this.speed * dt;
      this.lastMoveTime = this.scene.time.now;

      if (Math.abs(dx) > Math.abs(dy)) {
        this.facing = dx > 0 ? 'right' : 'left';
      } else {
        this.facing = dy > 0 ? 'down' : 'up';
      }
    }
  }

  destroy() {
    // No-op for Sprint 1.
  }
}
